import { Notyf } from 'notyf';

window.notyf = new Notyf({
    position: {
        x: "center",
        y: "top"
    },
    duration: 5000,
    dismissible: true,
    types: [
        {
            type: "success",
            background: "green"
        },
        {
            type: "error",
            background: "red"
        },
        {
            type: "warning",
            background: "orange"
        },
        {
            type: "info",
            background: "blue"
        },
    ]
});


/**
 * Axios interceptors.
 */
 window.axios.interceptors.response.use(function (response) {
    // global messages
    if (response.data && response.data.messages && response.data.messages.length > 0) {

        for (const message of response.data.messages) {
            notyf.dismissAll();
            notyf.open({
                type: message.type,
                message: message.content
            });
        }
    }
    return response;
});
